const FRASE = 'CONFIRMAR';
let pending = null;

function els(){
  return {
    root: document.getElementById('confirm'),
    msg: document.getElementById('confirm-msg'),
    input: document.getElementById('confirm-input'),
    ok: document.getElementById('confirm-ok'),
    hint: document.getElementById('confirm-hint'),
  };
}

function fechar(ok){
  const resolve = pending;
  pending = null;
  const { root, input, ok: btn, hint } = els();
  if(root) root.hidden = true;
  if(input) input.value = '';
  if(btn) btn.disabled = true;
  if(hint) hint.hidden = true;
  if(resolve) resolve(ok);
}

export function isConfirmOpen(){
  return Boolean(pending);
}

export function cancelarConfirmacao(){
  if(pending) fechar(false);
}

export function confirmarApagar(mensagem){
  if(pending) fechar(false);
  const { root, msg, input, ok, hint } = els();
  msg.textContent = mensagem;
  input.value = '';
  ok.disabled = true;
  hint.hidden = true;
  root.hidden = false;
  input.focus();
  return new Promise((resolve)=>{ pending = resolve; });
}

async function copiarFrase(){
  try{
    await navigator.clipboard.writeText(FRASE);
  }catch{
    const area = document.createElement('textarea');
    area.value = FRASE;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.left = '-9999px';
    document.body.appendChild(area);
    area.select();
    document.execCommand('copy');
    area.remove();
  }
  const { hint } = els();
  hint.hidden = false;
  hint.textContent = 'Copiado.';
}

export function bindConfirm(){
  const { root, input, ok } = els();
  input.addEventListener('input', ()=>{
    ok.disabled = input.value !== FRASE;
  });
  document.getElementById('confirm-cancel').addEventListener('click', ()=>fechar(false));
  root.addEventListener('click', (e)=>{ if(e.target === root) fechar(false); });
  ok.addEventListener('click', ()=>{ if(input.value === FRASE) fechar(true); });
  document.getElementById('confirm-copy').addEventListener('click', ()=>{ copiarFrase(); });
  input.addEventListener('keydown', (e)=>{
    if(e.key === 'Escape'){ e.preventDefault(); fechar(false); }
    if(e.key === 'Enter' && input.value === FRASE){ e.preventDefault(); fechar(true); }
  });
}
